export const mainFieldNames = {
  commercial_information: 'Commercial Truck Information',
  brands: 'Car Brands Serviced',
  all_brands: 'Services all brands',
  services: 'Services',
  hours_of_operation: 'Hours of Operations',
  st_phone: 'Ship To Phone Number',
  eligible_for_dealer_locator: 'Eligible For Locator',
  open_for_business: 'Open for Business',
  open_for_commercial_business: 'Open for Business',
  requested_geo_code: 'Request location change',
  toll_free_number: 'Toll Free Phone Number',
  after_hours_phone_number: 'After Hours Phone Number',
  geo_code: 'Geo Location Code',
  google_places_id: 'Google Places ID',
  store_number: 'Store #',
  lt_location: 'LT Location',
  aad_location: 'AAD Location',
  kad_location: 'KAD Location',
  tad_location: 'TAD Location',
  mailing_country: 'Country',
  mailing_address1: 'Address 1',
  mailing_address2: 'Address 2',
  mailing_city: 'City',
  mailing_state: 'State',
  mailing_zip: 'ZIP',
  st_fax: 'Fax',
  fax: 'Fax',
  customer_number: 'Customer Number',
  site_url: 'Website Address',
  store_email: 'Store Email',
  pos_details: 'POS Details',
  is_valid_physical_address: 'Valid Physical Address',
  is_active: 'Is Active',
  is_active_sds: 'Is Active',
  customer_dba_name: 'DBA Name',
  sales_agreement_codes: 'Sales Agreement Codes',
  customer_number_with_pos_provider: 'Dealer\'s Account Number with the POS Provider',
  pos_provider: 'POS Provider',
  pos_provider_technical_contact_name: 'POS Provider Technical Contact\'s Name',
  pos_provider_technical_contact_email: 'POS Provider Technical Contact\'s Email Address',
  pos_provider_technical_contact_phone: 'POS Provider Technical Contact\'s Phone Number',

  customer_addr1: 'Address 1',
  customer_addr2: 'Address 2',
  primaryTransportActivity: 'Primary Transport Activity',
  secondaryTransportActivity: 'Secondary Transport Activity',
  primaryVocation: 'Primary Vocation',
  secondaryVocation: 'Secondary Vocation',
  is_commercial: 'Is Commercial',
  address: 'Address',
  toll_free_number2: 'Toll Free Number 2',
  michelin_promo: 'Michelin Promo',
  bfg_promo: 'BFG Promo',
  mobile_only: 'Mobile Only',
  is_mobile_only: 'Mobile Only',
  geo_code_latitude: 'Latitude',
  geo_code_longitude: 'Longitude',
  requested_geo_code_update: 'Requested location change',
  requested_geo_code_latitude: 'Requested latitude',
  requested_geo_code_longitude: 'Requested longitude',
  requested_geo_code_explanation: 'Requested explanation',
  sells_michelin: 'Sells Michelin',
  sells_bfgoodrich: 'Sells BFGoodrich',
  sells_uniroyal: 'Sells Uniroyal',
  has_hours_of_operation: 'Has Hours of Operation',
  warehouse_flag: 'Warehouse Flag',
  headquarters_flag: 'Headquarters Flag',
  retail_location_flag: 'Retail Location Flag',
  servicing_dealer_bt: 'Servicing  Dealer Bill To',
  aad_group_bt: 'AAD Group Bill To',
  ship_to_number: 'Ship To',
  bill_to_number: 'Bill To',
  commercial_truck_location: 'Commercial Truck Location',
  accepted_date: 'Accepted Date',
  has_pos_system: 'Has POS System',
  on_locator: 'On Locator',
  ext: 'Ext.',
  group: 'Group/Shared',

  // Contacts
  cell_phone: 'Cell Phone',
  contact_level: 'Contact Level',
  contact_types: 'Contact Types',
  create_user: 'Create User',
  created_date: 'Created Date',
  current_version: 'Current Version',
  email_address: 'Email Address',
  first_name: 'First Name',
  last_name: 'Last Name',
  job_title: 'Job Title',
  location_assigned: 'Location Assigned',
  notification_subscription: 'Notification Subscription',
  preferred_language: 'Preferred Language',
  preferred_method: 'Preferred Method',
  visible_externally: 'Visible Externally',
  work_hours: 'Work Hours',
  work_phone: 'Work Phone',
  certifications: 'Certifications',
  outside_certifications: 'Outside Certifications',
  commercial: 'Commercial',
  retail: 'Retail',
  is_deleted: 'Deleted',

  // Location Information - Commercial
  service_address: 'Address',
  service_city: 'City',
  service_state: 'State',
  service_country: 'Country',
  service_zip: 'ZIP',
  service_address_longitude: 'Longitude',
  service_address_latitude: 'Latitude',
  service_radius: 'Radius',
  service_request_email: 'Service Request Email',
  secondary_after_hours_phone_number: 'Secondary After Hours Phone Number',
  county: 'County',
  mechanical_hours_of_operation: 'Mechanical Services Hours of Operations',
  customer_inter_hwy_info: 'Interstate/Hwy Exit Information',

  // Products
  x_one_tires: 'X-One Tires',
  oliver_retreads: 'Oliver Retreads',
  megamile_retreads: 'Megamile Retreads',
  ultra_low_profile_wide_design_retreads: 'Ultra Low Profile Wide Design Retreads',
  mrt_dealer: 'MRT Dealer',
  customer_type: 'Customer Type',

  // Network
  tire_care_member: 'Member of Michelin Tire Care',
  mechanical_care_dealer: 'Member of Michelin Mechanical Care',

  // ERS Information
  mechanical_same_hours_as_tires_ers_services: 'Same as Tire ERS Services',
  provides_247365_ers_services: 'Provides 24/7 ERS Services',
  number_of_trucks: 'Number of Trucks',
  photo_of_truck: 'Photo of Truck',
  dot_inspection: 'DOT Inspection',
  ers_mechanical_services_provided: 'ERS Mechanical Services',
  towing: 'Towing',
  suspension_repair: 'Suspension Repair',
  brakes_repair: 'Brakes Repair',
  jump_starts: 'Jump Starts',
  electric_vehicle_charging: 'Electric Vehicle Charging',
  fuel_delivery: 'Fuel Delivery',
  diagnostic_services: 'Diagnostic Services',
  lockouts: 'Lockouts',
  lights: 'Lights',
  oncall_sds_dashboard: 'Enabled for use and access of the ONCall DR Dashboard',
  is_fixpix_location: 'Enabled for use and access of the FixPix App',
  do_you_have_trucks: 'Do you have Tire Service Trucks',
  rv_dealer: 'RV Dealer',
  motor_coach_dealer: 'Motor Coach Dealer',
  provides_247365_ers_service: 'Provides 24/7/365 Tire ERS Service',
  // Tire Services
  mounted_wheel_program: 'Mounted Wheel Program',
  nail_hole_repair: 'Nail Hole Repair',
  tire_balancing: 'Tire Balancing',
  tire_inspections: 'Tire Inspections',
  tire_mounting: 'Tire Mounting',
  tire_repairs: 'Tire Repairs',
  tire_rotations: 'Tire Rotations',
  tire_services_hours_of_operation: 'Tire Services Hours of Operations',
  tpms_reset_and_replacement: 'TPMS Reset and Replacement',
  vehicle_alignment: 'Vehicle Alignment',
  tia_certified_technicians: 'TIA Certified Technicians (OSHA Compliant)',
  training_200_ats: '200 (Training) ATS',
  training_200_cts: '200 (Training) CTS',
  certificate_or_equivalent_300_ats: '300 (Certficate or Equivalent) ATS',
  wheel_refurbishing: 'Wheel Refurbishing',
  polishing: 'Polishing (Aluminum)',
  powder_coating: 'Powder Coating (Steel)',

  // Mechanical Services
  complete_mechanical: 'Complete Mechanical',
  ase_certified_mechanics: 'ASE Certified Mechanics',
  a1_engine_repair: 'A1 - Engine Repair',
  a2_automatic_transmission_transaxle: 'A2 - Automatic Transmission/Transaxle',
  a3_manual_drive_train_and_axles: 'A3 - Manual Drive Train & Axles',
  a4_suspension_and_steering: 'A4 - Suspension & Steering',
  a5_brakes: 'A5 - Brakes',
  a6_electrical_electronic_systems: 'A6 - Electrical/Electronic Systems',
  a7_heating_and_air_conditioning: 'A7 - Heating & Air Conditioning',
  a8_engine_performance: 'A8 - Engine Performance',
  a9_light_vehicles_diesel_engines: 'A9 - Light Vehicle Diesel Engines',
  g1_auto_maintenance_and_light_repair: 'G1 - Auto Maintenance and Light Repair',
  l3_light_duty_hybrid_electric_vehicle: 'L3 - Light Duty Hybrid / Electric Vehicle',
  heavy_duty_tractor_oe_manufacturers: 'Heavy Duty Tractor (OE Manufacturers)',
  heavy_duty_trailer_oe_manufacturers: 'Heavy Duty Trailer (OE Manufacturers)',
  medium_duty_oe_manufacturers: 'Medium Duty (OE Manufacturers)',
  less_than_10_lbs: 'Towing < 10,000 lbs',
  between_10_and_26_lbs: 'Towing from 10,000 to 26,000 lbs',
  greater_than_26_lbs: 'Towing > 26,000 lbs',
  alignment: 'Alignment',
  alternator_replacement: 'Alternator Replacement',
  basic_brake_service: 'Basic Brake Service',
  basic_electrical: 'Basic Electrical',
  dot_annual_inspection: 'DOT Annual Inspection',
  light_replacement: 'Light Replacement',
  minor_body_repair: 'Minor Body Repair',
  seals_and_bearing_replacement: 'Seals & Bearing Replacement',
  trailer_inspection: 'Trailer Inspection',
  vehicle_disinfecting: 'Vehicle Disinfecting',
  vehicle_washes: 'Vehicle Washes',
  wheel_end_replacement: 'Wheel End Replacement',
  air_conditioning_repair_pu: 'Air Conditioning Repair (PU)',
  air_filter_replacement_pu: 'Air Filter Replacement (PU)',
  alignment_pu: 'Alignment (PU)',
  alternator_replacement_pu: 'Alternator Replacement (PU)',
  basic_brake_service_pu: 'Basic Brake Service (PU)',
  basic_electrical_pu: 'Basic Electrical (PU)',
  battery_replacement_pu: 'Battery Replacement (PU)',
  belts_and_hoses_pu: 'Belts & Hoses (PU)',
  cabin_filter_replacement_pu: 'Cabin Filter Replacement (PU)',
  dot_annual_inspection_pu: 'DOT Annual Inspection (PU)',
  electric_vehicle_charging_pu: 'Electric Vehicle Charging (PU)',
  full_unit_inspection_pu: 'Full Unit Inspection (PU)',
  light_replacement_pu: 'Light Replacement (PU)',
  lightbulb_replacement_pu: 'Lightbulb Replacement (PU)',
  state_inspection_pu: 'State Inspection (PU)',
  seals_and_bearing_replacement_pu: 'Seals & Bearing (PU) Replacement',
  suspension_pu: 'Suspension (PU)',
  vehicle_disinfecting_pu: 'Vehicle Disinfecting (PU)',
  vehicle_washes_pu: 'Vehicle Washes (PU)',
  wheel_end_replacement_pu: 'Wheel End Replacement (PU)',
  windshield_wipers_pu: 'Windshield Wipers (PU)',
  brake_fluid: 'Brake Fluid',
  brake_fluids: 'Brake Fluid',
  coolant: 'Coolant',
  diesel_emission_fluid: 'Diesel Emissions Fluid (DEF)',
  fuel_refill_diesel: 'Fuel Refill - Diesel',
  fuel_refill_gas: 'Fuel Refill - Gas',
  oil: 'Oil',
  power_steering_fluid: 'Power Steering Fluid',
  transmission_fluid: 'Transmission Fluid',
  windshield_fluid: 'Windshield Fluid',
  differential: 'Differential',
  fuel_system_cleaning: 'Fuel System Cleaning',
  transmission: 'Transmission',
  oil_change: 'Oil Change',
  brake_fluid_exchange: 'Brake Fluid Exchange',
  coolant_exchange: 'Coolant Exchange',
  differential_fluid_exchange: 'Differential Fluid Exchange',
  fuel_system_repair: 'Fuel System Repair',
  power_steering_fluid_exchange: 'Power Steering Fluid Exchange',
  transfer_case_fluid_exchange: 'Transfer Case Fluid Exchange',
  transmission_fluid_exchange: 'Transmission Fluid Exchange',

  electrical_diagnostics: 'Electrical Diagnostics',
  engine_diagnostics_basic: 'Engine Diagnostics - Basic',
  engine_diagnostics_advanced: 'Engine Diagnostics - Advanced',
  transmission_basic: 'Transmission - Basic',
  transmission_advanced: 'Transmission - Advanced',

  // Overrides
  overrides: 'Overrides',
  overrides_value: 'Overrides Value',
  on_tire_locator: 'Tire/Retread Locator',
  on_mechanical_locator: 'Mechanical Locator',
  mcsn_member: 'MCSN Member',
  mcsn: 'MCSN',
  service_tier_ranking: 'Service Rank',
  service_tier_ranking_value: 'Rank',
  service_tier_ranking_reason: 'Reason',
  calc_onlocator_tires: 'Calc Onlocator Tires',
  calc_onlocator_mechanical: 'Calc Onlocator Mechanical',

  // Retail Programs
  programs: 'Programs / National Accounts',
  processes_national_accounts: 'Processes National Accounts',
  autointegrate: 'Auto Integrate',
  michelin_national_account: 'Michelin National Account',
  rec_offroad_specialist: 'Rec Off-Road Specialist',
  uhp_specialist: 'Ultra High Performance Specialist',
  nafa_urban_participant: 'NAFA Urban Participant',
  mounted_wheel_service: 'Mounted Wheel Service',
  loose_tire_pickup: 'Loose Tire Pickup',

  // Retail Languages
  languages: 'Languages',
  english: 'English',
  french: 'French',
  spanish: 'Spanish',

  // Retail Customer Convenience
  customer_convenience: 'Customer Convenience',
  waiting_area_available: 'Waiting Area Available',
  child_friendly_waiting_rm: 'Separate Child Play Area',
  financing_available: 'Financing Available',
  overnight_key_drop: 'Offers Overnight Key Drop',
  customer_pickup_drop_off: 'Customer Pick-Up / Drop-Off Service Offered',
  loaner_vehicles: 'Offers Loaner Vehicles',

  // Retail Vehicle Types Serviced
  vehicle_types_serviced: 'Vehicle Types Serviced',
  passenger_lt: 'Passenger / Light Truck',
  light_commercial: 'Light Commercial',
  medium_commercial: 'Medium Commercial',
  heavy_commercial: 'Heavy Commercial',

  // Retail ERS Services
  ers_services: 'ERS Services',
  roadside_service: 'Roadside Service',
  roadside_service_24hs: 'Roadside Service 24hrs',
  roadside_service_24_hrs: 'Roadside Service 24hrs',
  towing_service: 'Towing',
  towing_service_24hs: 'Towing 24hrs',
  towing_service_24_hrs: 'Towing 24hrs',

  // Services - Protections/Warranties
  protections_and_warranties: 'Protections And Warranties',

  // Retail Mechanical Services
  mechanical_services: 'Mechanical Services',
  air_conditioning: 'Air Conditioning',
  battery: 'Battery',
  belts_and_hoses: 'Belts and Hoses',
  complete_brake_service: 'Complete Brake Service',
  front_end_axle_cv_repair: 'Front End/Axle/CV Repair',
  oil_filter_lube: 'Oil, Filter and Lube',
  major_mech_repair: 'Major Mechanical Repair',
  service_electric_cars: 'Service Electric Vehicles',
  state_inspection: 'State Inspection',
  shocks_and_struts: 'Shocks and Struts',

  // Retail Tire and Related Services
  tire_services: 'Tire Services',
  all_wheel_alignment: 'All Wheel Alignment',
  computer_balancing: 'Computer Balancing',
  custom_wheel_sales: 'Custom Wheel Sales',
  farm_tire_service: 'Farm Tire Service',
  tire_installation_service: 'Tire Installation Service',
  rv_tire_sales: 'RV Tire Sales',
  service_and_mount_hp_tires: 'Service and Mount High Performance Tires',
  service_and_mount_std_tires: 'Service and Mount Standard Tires',
  service_run_flat_tires: 'Service Run-Flat Tires',
  service_tpms: 'Service Tire Pressure Monitoring Systems',
  tire_inflation_with_nitrogen: 'Tire Inflation with Nitrogen',
  winter_tire_studding: 'Winter Tire Studding',
  wheel_sales: 'Wheel Sales',

  // Retail Service Radius
  retail_service_radius: 'Retail Service Radius',

  // Technician service areas
  primary_st_locations: 'Primary ST Locations',
  secondary_st_locations: 'Secondary ST Locations',
};

export const getFieldLabel = (field: string) => (mainFieldNames as any)[field] || field;
